import React from "react";
import { Button } from "@mui/material";
import MuPagination, { PaginationProps as MuPaginationProps } from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export type PaginationProps = MuPaginationProps & {};

const Pagination = ({ ...others }: PaginationProps) => {
  const CustomPrev = () => {
    return (
      <Button
        disableRipple
        variant="text"
        color="primary"
        sx={{
          margin: 0,
          px: 0,
          py: "12px",
        }}
        startIcon={<ArrowBackIcon />}>
        Previous
      </Button>
    );
  };
  const CustomForward = () => {
    return (
      <Button
        disableRipple
        variant="text"
        color="primary"
        sx={{
          margin: 0,
          px: 0,
          py: "12px",
        }}
        endIcon={<ArrowForwardIcon />}>
        Next
      </Button>
    );
  };

  return (
    <MuPagination
      sx={{
        "& .MuiPagination-ul li:first-child": {
          marginRight: "auto",
        },
        "& .MuiPagination-ul li:last-child": {
          marginLeft: "auto",
        },
        width: "100%",
      }}
      shape="rounded"
      size="large"
      renderItem={item => (
        <PaginationItem
          slots={{ previous: CustomPrev, next: CustomForward }}
          {...item}
          color="primary"
          variant="text"
        />
      )}
      {...others}
    />
  );
};

export default Pagination;
